import React, { useState, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Table } from "antd";
import CaseDetailModal from "../../modals/caseDetailModal";
import DelTableRowModal from "../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
import { getAllCases } from "../../APIs/caseApis";
import { message } from "antd";

const Filesupload = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [cases, setCases] = useState([]);
  const [allCases, setAllCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [iscaseDetailOpen, setiscaseDetailOpen] = useState(false);
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const datePickerRef = useRef(null);

  const categories = [
    "Client Information",
    "Contract Management",
    "Evidence Management",
    "Incident Details",
  ];


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };
  const onviewClick = () => {
    setiscaseDetailOpen(true);
  };
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };

  // const data = [
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "1",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Client Information",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "2",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Contract Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  //   {
  //     key: "3",
  //     id: "C1234",
  //     title: "Case1",
  //     category: "Evidence Management",
  //     deadline: "10/15/2024",
  //     uploadBy: "John Doe",
  //   },
  // ];

  const columns = [
    {
      title: t("adminDashboard.filesUpload.id"),
      dataIndex: "id",
      key: "id",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.filesUpload.tableTitle"),
      dataIndex: "title",
      key: "title",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.filesUpload.category"),
      dataIndex: "category",
      key: "category",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.filesUpload.deadline"),
      dataIndex: "deadline",
      key: "deadline",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.filesUpload.uploadBy"),
      dataIndex: "uploadBy",
      key: "uploadBy",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.filesUpload.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[8px]  items-center">
          <img
            src="../../assets/icons/eye.png"
            alt=""
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onviewClick}
          />
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  console.log("Final Cases Data in State:", cases);
  return (
    <>
      <div className="flex flex-col h-full">
        <div className="top bg-[#EFF0F2] rounded-t-[20px] px-[20px] py-[18px] sm-s:flex-col sm-s:gap-[20px] flex items-center justify-between">
          <h5 className="small text-blue font-bold">
            {t("adminDashboard.filesUpload.title")} (200)
          </h5>

          <div className="left-div gap-[20px] flex items-center sm-s:flex-col">
            <div className="flex gap-[8px] items-center">
              <p className="small font-medium">
                {t("adminDashboard.filesUpload.category")}:
              </p>
              <Select
                placeholder={t("adminDashboard.filesUpload.all")}
                style={{ width: 148 }}
                className="admin-filesdropdown"
              >
                {categories.map((categories, index) => (
                  <Option key={index} value={categories}>
                    {categories}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="flex gap-[8px] items-center">
              <p className="small font-medium">
                {t("adminDashboard.filesUpload.date")}:
              </p>
              <div className="flex items-center gap-[10px] rounded-[10px] p-[10px] max-w-[158px]  dropdown-back">
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  className="text-[#8D8D8D] bg-transparent max-w-[90%] font-medium small font-montserrat"
                  dateFormat="MM/dd/yyyy"
                  ref={datePickerRef}
                />
                <Icon
                  icon="clarity:date-line"
                  className="text-gray-500 cursor-pointer"
                  onClick={handleIconClick}
                  width={18}
                  height={18}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bottom py-[18px] px-[10px]">
          <Table
            columns={columns}
            // dataSource={data}
            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div>
      </div>
      <DelTableRowModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
      <CaseDetailModal
        iscaseDetailOpen={iscaseDetailOpen}
        setiscaseDetailOpen={setiscaseDetailOpen}
      />
    </>
  );
};

export default Filesupload;
